import { Component, OnInit, ViewChild } from '@angular/core';
import { NzModalRef, NzMessageService } from 'ng-zorro-antd';
import { SFSchema, SFUISchema } from '@delon/form';
import {FormBuilder, FormControl, FormGroup, ValidationErrors, Validators} from "@angular/forms";
import {Observable, Observer} from "rxjs/index";
import {until} from "selenium-webdriver";
import elementIsDisabled = until.elementIsDisabled;
import {DictService} from "@ecip/service";
import {CacheService} from "@delon/cache";

@Component({
  selector: 'app-system-dict-edit',
  templateUrl: './edit.component.html',
})
export class SystemDictEditComponent implements OnInit {
  record: any = {};
  i: any;
  isRoot: boolean;
  form: FormGroup;
  parent;
  ableOperate: boolean;
  stateList = this.cacheService.get(`api/dict/type/enableState`);


  constructor(
    private modal: NzModalRef,
    public msgSrv: NzMessageService,
    private fb: FormBuilder,
    public dictService: DictService,
    private cacheService: CacheService
    ) {}

  ngOnInit(): void {
    let pid = null;
    let dictType = '';
    if (!this.record.id) {
      if (this.isRoot) {
        this.ableOperate = true;
      }else {
        this.ableOperate = false;
        pid = this.parent.id;
        dictType = this.parent.dictType;
      }
    }

    this.form = this.fb.group({
      pid: [pid, []],
      dictType: [dictType, [Validators.required], [this.typeAsyncValidator]], //SystemDictEditComponent.typeAsyncValidator(this.dictService, this.record)
      vkey: ['', [], [this.codeAsyncValidator]], //SystemDictEditComponent.codeAsyncValidator(this.dictService, this.record, this.parent)
      vname: [null, [Validators.required]],
      remark: [null, []],
      sortNum: [0, [Validators.required]],
      rsvn: [null, []],
      valid: [1, [Validators.required]],
      createTime: [null, []],
      updateTime: [null, []],
      creator: [null, []],
      operator: [null, []],
    });

    if (!this.record.id) {
      return ;
    }

    if(this.isRoot){
      let vkeyCtl = this.form.get("vkey");
      vkeyCtl.clearAsyncValidators();
      vkeyCtl.updateValueAndValidity();
    }


    this.dictService.getById(this.record.id).subscribe(
      (res: any) => {
        this.isRoot = !res.pid;
        this.form.patchValue(res);
        this.i = res;
      });
  }

  compareNumStr(c1: any, c2: any): boolean {
    return c1 == c2;
  }

  codeAsyncValidator = (control: FormControl) =>
    Observable.create((observer: Observer<ValidationErrors>) => {
      if (!control.value) {
        observer.next(null);
        observer.complete();
        return;
      }
      let parentId = this.parent ? this.parent.id : null;
      this.dictService.checkVkey({id: this.record.id, pid: parentId, vkey: control.value}).subscribe((res: any) => {
        if (res.valid === true) {
          observer.next(null);
        } else {
          observer.next({error: true, duplicated: true});
        }
        observer.complete();
      });
    });

  typeAsyncValidator = (control: FormControl) =>
    Observable.create((observer: Observer<ValidationErrors>) => {
      if (!control.value) {
        observer.next(null);
        observer.complete();
        return;
      }
      if (this.isRoot){
        this.dictService.checkDictType({id: this.record.id, dictType: control.value}).subscribe((res:any)=> {
          if (res.valid === true) {
            observer.next(null);
          } else {
            observer.next({ error: true, duplicated: true });
          }
          observer.complete();
        });
      }
      else {
        observer.next(null);
        observer.complete();
      }
    });

  submit() {
    for (const i in this.form.controls) {
      this.form.controls[i].markAsDirty();
      this.form.controls[i].updateValueAndValidity();
    }
    if (this.form.invalid) return;
    if (!this.record.id) {
      //æ°å¢
      this.dictService.post(this.form.value).subscribe(res => {
        this.msgSrv.success('ä¿å­æå');
        this.modal.close(res);
      });
      return;
    }
    //ä¿®æ¹
    this.dictService.put(this.record.id, this.form.value).subscribe(res => {
      this.msgSrv.success('ä¿å­æå');
      this.modal.close(res);
    });
  }

  close() {
    this.modal.destroy();
  }
}
